export default __webpack_public_path__ + "static/media/market-launch.18332e31.svg";